export default {
    INFO: 'info',
    WARNING: 'warning',
    CRITICAL: 'critical',
    SUCCESS: 'success'
};
